module.exports = __webpack_public_path__ + "img/TWM-Pack.517bc712.jpg";